import { Component } from '@angular/core';
import { CurrentFacilityService } from 'src/app/shared/services';

@Component({
    selector: 'app-facility-information-empty',
    templateUrl: './facility-information-empty.component.html',
    styleUrls: ['./facility-information-empty.component.scss'],
    standalone: false,
})
export class FacilityInformationEmptyComponent {
    public facilityName = '';

    constructor(private currentFacilityService: CurrentFacilityService) {
        this.facilityName = this.currentFacilityService.getFacilitySource();
    }
}
